import React from 'react';
import { useInterview } from '@components/pass/interview/start/context/interviewContext';
import style from './body.module.scss';
import classnames from 'classnames/bind';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import Icon from '@components/common/assets';
import Button from '@components/common/button';
import PageTopButton from '@components/common/pageTopButton';

const cx = classnames.bind(style);

interface QuestionSelectBodyProps {
  onClickNext: (e: React.MouseEvent<HTMLElement>) => void;
  children?: React.ReactNode;
}

const InterviewPracticeQuestionSelectBody = (props: QuestionSelectBodyProps) => {
  const { selectedQuestionList, policies } = useInterview();
  const isDisable = selectedQuestionList.length < policies.interviewPracticeMinQuestionSize;
  const selectedQuestionCount = selectedQuestionList.length;

  return (
    <div className={cx('body')}>
      <div className={cx('contentWrap')}>{props.children}</div>

      <div className={cx('footer')}>
        <div className={cx('content')}>
          <div className={cx('infoArea')}>
            <Icon name="informationLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
            <Text
              fontStyle={FontStyle.B2P_M}
              color={Colors.C_COOL_GRAY_60}
              styles={{
                marginLeft: 4,
              }}
            >
              질문은 최대 {policies.interviewPracticeMaxQuestionSize}개까지 선택 가능해요
            </Text>
            <div className={cx('divider')} />
            <Text
              fontStyle={FontStyle.B2P_M}
            >{`${selectedQuestionCount}/${policies.interviewPracticeMaxQuestionSize}`}</Text>
          </div>

          <Button className={cx('btn')} onClick={props.onClickNext} disabled={isDisable}>
            다음
          </Button>
        </div>
      </div>

      {/* 탑 이동 */}
      <PageTopButton />
    </div>
  );
};

export default InterviewPracticeQuestionSelectBody;
